const testimonials = [
  {
    id: 1,
    name: 'Elok Marta Saputra',
    title: 'Junior React Native Developer',
    org: 'Binar x Glints Academy',
    desc:
      'During Final Project for the Bootcamp, we are at the same team and he act as our leader or Scrum Master, and I admit he has superb leadership skill, I really admired his leadership. ',
  },
  {
    id: 2,
    name: 'Senno Hananto',
    title: 'Mentor Quality',
    org: 'Binar Academy',
    desc:
      'Agus Zohari is a Web Engineer who has amazing web development skills. To support his hard skills, he also has soft skills, excellent communication and leadership skills.',
  },
  {
    id: 3,
    name: 'Budi Hartono',
    title: 'Junior Back End Developer',
    org: 'Binar x Glints Academy',
    desc:
      'Agus prioritizes team discipline in completing a project, has a leadership spirit that I feel is really a leader for all team members, works with targets, good communication and is open in terms of sharing knowledge.',
  },
  {
    id: 4,
    name: 'Rizky Amelia Yulistianingsih',
    title: 'React Native Developer',
    org: 'Binar x Glints Academy',
    desc:
      'His hands-on strategy to leadership, communication, eager to learn, fast-learner and strong character gained him the respect of the team.',
  },
  {
    id: 5,
    name: 'Angela Gizz',
    title: 'Junior Front End Developer',
    org: 'Binar x Glints Academy',
    desc:
      'Agus is someone who is critical in completing tasks, focused and has unlimited creativity. He is someone who has a high willingness to learn so that his ability in front end development is unquestionable.',
  },
];
export default testimonials;
